import React, { FC } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Scan } from '../../../common/model/dto/scan';
import {
  scanErrorDisplay,
  scanWarningDisplay,
  scanWarningsDisplay,
} from '../../../common/utils/services/scan-data-utils';
import Colours from '../../../design-system/colours';
import Variables from '../../../design-system/variables';

const WARNINGS_LIST_MIN_TOOLKIT_VERSION = '1.3.0';

const OvScanResultSummary: FC<{ scan: Scan }> = ({ scan }) => {
  const { t } = useTranslation();
  const output = scan.toolkit_output;
  const hasWarningList =
    (output?.version ?? '') >= WARNINGS_LIST_MIN_TOOLKIT_VERSION;
  const hormones = [
    { label: t('common.dailyData.lh'), value: scan.displayLh?.value },
    { label: t('common.dailyData.pg'), value: scan.displayPg?.value },
    { label: t('common.dailyData.e3g'), value: scan.displayLrE3g?.value },
  ].filter(({ value }) => !!value);

  return (
    <>
      {hormones.map(({ label, value }) => (
        <Hormone key={label}>
          <b>{label}</b>: {value}
        </Hormone>
      ))}
      {!hasWarningList && output?.warning && (
        <Issue>{scanWarningDisplay(output.warning)}</Issue>
      )}
      {hasWarningList && !!output?.warnings?.length && (
        <Issue>{scanWarningsDisplay(output.warnings)}</Issue>
      )}
      {hasWarningList && output?.error && (
        <Issue $isError>{scanErrorDisplay(output.error)}</Issue>
      )}
    </>
  );
};

export default OvScanResultSummary;

const Hormone = styled.div`
  white-space: nowrap;
`;

const Issue = styled.div<{ $isError?: boolean }>`
  max-width: 22rem;
  margin-top: 0.25rem;
  color: ${({ $isError }) =>
    $isError ? Colours.OV_ERROR_ACCESSIBLE : Colours.OV_CHARCOAL};
  font-size: ${Variables.fontSizes.SMALL};
`;
